import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import { formatarNomeUpper, formatarData } from "../../utils/formatadores";
import configTiposCompromisso from "../../pages/agenda/configTiposCompromisso"; // Ajuste o caminho correto

const Principal = () => {
  const navigate = useNavigate();
  
  // Estados completamente independentes
  const [audienciasProximas, setAudienciasProximas] = useState([]);
  const [outrosCompromissos, setOutrosCompromissos] = useState([]);
  const [aniversariantes, setAniversariantes] = useState([]);

  // 1. Função dedicada EXCLUSIVAMENTE para Audiências
  const carregarAudienciasProximas = async () => {
    try {
      const response = await api.get("/compromissos?tipo=audiencia&status=pendente&proximaSemana=true");
      setAudienciasProximas(response.data);
    } catch (err) {
      console.error("Erro ao carregar audiências para o modal:", err);
    }
  };

  // 2. Outros Compromissos: passa proximosDias=10
  const carregarOutrosCompromissos = async () => {
    try {
      const response = await api.get("/compromissos?tipo=outros_exceto_audiencia&status=pendente&proximosDias=10");
      setOutrosCompromissos(response.data);
    } catch (err) {
      console.error("Erro ao carregar outros compromissos:", err);
    }
  };

  // 3. Função dedicada EXCLUSIVAMENTE para Aniversariantes
  const carregarAniversariantes = async () => {
    try {
      const response = await api.get("/clientes/aniversariantes/hoje");
      setAniversariantes(response.data);
    } catch (err) {
      console.error("Erro ao carregar aniversariantes:", err);
    }
  };

  useEffect(() => {
    carregarAudienciasProximas();
    carregarOutrosCompromissos();
    carregarAniversariantes();
  }, []);

  // Helper para recuperar a label formatada de acordo com o configTiposCompromisso
  const obterLabelTipo = (tipo) => {
    const tipoNormalizado = tipo?.toLowerCase().trim();
    return configTiposCompromisso[tipoNormalizado]?.label || formatarNomeUpper(tipo) || "Compromisso";
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <div className="logo_principal">
        <img
          src="logo_aplicacao.png"
          alt="Logo do escritório"
          style={{ width: "400px", height: "330px" }}
        />
      </div>

      <div className="modais-lateral-esquerda">
        {/* MODAL 1: AUDIÊNCIAS */}
        <div className="modal-lateral-card">
          <h3>Audiências (Próximos 7 Dias)</h3>
          <div className="modal-lista-scroll">
            {audienciasProximas.length > 0 ? (
              audienciasProximas.map((item) => (
                <div
                  key={item._id}
                  className="modal-linha-registro"
                  onClick={() => navigate("/agenda/consultar")}
                  title="Clique para ver na Agenda"
                >
                  <span className="data-reg">{formatarData(item.dataAudiencia || item.dataPrazo)}</span>
                  <span className="parte-reg">{formatarNomeUpper(item.nomeParte) || "Processo"}</span>
                </div>
              ))
            ) : (
              <p className="modal-vazio">Nenhuma audiência nos próximos 7 dias.</p>
            )}
          </div>
        </div>

        {/* MODAL 2: OUTROS COMPROMISSOS (SEPARADO) */}
        <div className="modal-lateral-card">
          <h3>Outros Compromissos (Próximos 10 Dias)</h3>
          <div className="modal-lista-scroll">
            {outrosCompromissos.length > 0 ? (
              outrosCompromissos.map((item) => (
                <div
                  key={item._id}
                  className="modal-linha-registro"
                  onClick={() => navigate("/agenda/consultar")}
                  title="Clique para ver na Agenda"
                >
                  <span className="data-reg">{formatarData(item.dataManifestacao || item.dataPrazo)}</span>
                  <span className="parte-reg">
                    <strong>[{obterLabelTipo(item.tipo)}]</strong> {formatarNomeUpper(item.nomeParte) || item.processoId?.numeroProcesso || "Sem Parte/Processo"}
                  </span>
                </div>
              ))
            ) : (
              <p className="modal-vazio">Nenhum outro compromisso pendente.</p>
            )}
          </div>
        </div>

        {/* MODAL 3: ANIVERSARIANTES */}
        <div className="modal-lateral-card">
          <h3>🎉 Aniversariantes de Hoje 🎉</h3>
          <div className="modal-lista-scroll">
            {aniversariantes.length > 0 ? (
              aniversariantes.map((cliente) => (
                <div key={cliente._id} className="modal-linha-registro">
                  <span className="parte-reg">{formatarNomeUpper(cliente.nomeCliente)}</span>
                  <span className="tel-reg">{cliente.telefone || ""}</span>
                </div>
              ))
            ) : (
              <p className="modal-vazio">Nenhum aniversariante hoje.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Principal;